import { useMediaHook } from "../useMediaHook";
import { API } from "../../../Constants/APIs";
import { Check } from "@material-ui/icons";
import ExitBtn from "../ExitBtn";
import React, { useRef } from "react";
import "./components.css";

const Components = ({ propState, selectMaterial, checkSelected }) => {
  const isMdOrDown = useMediaHook();
  const ref = useRef();
  return (
    <div
      className="bgWhiteTopMost SDM_COMPO_components"
      ref={ref}
      style={{
        border: "0px solid red",
        zIndex: 2000,
        scrollbarWidth: "8px",
      }}
    >
      {!isMdOrDown && (
        <ExitBtn
          rightAlign={true}
          onClick={() => {
            ref.current.classList.toggle("close");
          }}
        />
      )}
      {/* Contents */}
      <div
        className="SDM_COMPO_content NO_SCROLLBAR"
        style={{
          borderRight: 0,
          borderTop: isMdOrDown ? "0px solid #ddd" : 0,
          borderBottom: isMdOrDown ? "0px solid #ddd" : 0,
          maxHeight: isMdOrDown ? "115px" : "300px",
          height: "100%",
          borderRadius: isMdOrDown ? 0 : `0px 15px 15px 0px`,
          boxShadow: "none",
          maxWidth: "100%",
          width: "100%",
          overflow: "auto",
          paddingLeft: isMdOrDown ? "0" : "1.25rem",
          display: isMdOrDown ? "flex" : "block",
          flexWrap: "nowrap",
          // scrollbarWidth: "none",
        }}
      >
        {propState.Components.map((single, index) => (
          <div
            className="SDM_COMPO_oneCompo"
            key={`${single?.component_name}-${index}`}
            style={{
              border: "0px solid aqua",
              marginRight: isMdOrDown ? "1.25rem" : 0,

              scrollbarWidth: "none",

              // marginBottom: isMdOrDown ? "1.5rem" : 0,
            }}
          >
            <div
              className="SDM_COMPO_compoTitle"
              style={{
                fontWeight: isMdOrDown ? 500 : 400,
                fontSize: isMdOrDown ? "17px" : "15px",
                marginBottom: "0.6rem",
              }}
            >
              {single?.component_name}
            </div>

            <div
              className="SDM_COMPO_compoMaterials"
              style={{
                display: isMdOrDown ? "flex" : "inline-flex",
                flexDirection: isMdOrDown ? "row" : "column",
                alignItems: isMdOrDown ? "flex-start" : "center",
                justifyContent: isMdOrDown ? "space-around" : "flex-start",
                paddingRight:
                  !isMdOrDown || propState.Components.length - 1 == index
                    ? 0
                    : "10px",
                borderRight:
                  !isMdOrDown || propState.Components.length - 1 == index
                    ? 0
                    : "2px solid #ddd",
                scrollbarWidth: 0,
              }}
            >
              {single.materials?.map((material, indexM) => {
                return (
                  <React.Fragment key={`${material.title}-${indexM}`}>
                    <div
                      className="SDM_COMPO_singleMaterial"
                      style={{
                        width: isMdOrDown ? 49 : 50,
                        border: "0px solid red",
                        marginRight: isMdOrDown ? "1rem" : 0,
                        scrollbarWidth: "none",
                        border: "0px solid blue",
                        cursor: "pointer",
                      }}
                      key={`${material.title}-${indexM}`}
                      onClick={() => {
                        selectMaterial(material._id, single._id);
                      }}
                    >
                      {material.material_type === "color" ? (
                        <div
                          className="SDM_COMPO_materialFig"
                          style={{
                            width: isMdOrDown ? 51 : 50,
                            height: isMdOrDown ? 51 : 50,
                            borderRadius: 5,
                            boxShadow: `0px 4px 4px rgba(0, 0, 0, 0.25)`,
                            backgroundColor: material.material_value,
                            display: "grid",

                            placeItems: "center",
                            border: "0px solid red",
                            position: "relative",
                          }}
                        >
                          {!checkSelected(material._id, single._id) ? (
                            ""
                          ) : (
                            <div
                              style={{
                                display: "grid",
                                placeItems: "center",
                                position: "absolute",
                                top: 0,
                                bottom: 0,
                                left: 0,
                                right: 0,
                                background: "rgba(0,0,0,0.1)",
                              }}
                            >
                              <Check
                                size="large"
                                style={{
                                  color: "#000",
                                }}
                              />
                            </div>
                          )}
                        </div>
                      ) : (
                        <div
                          className="SDM_COMPO_materialFig"
                          style={{
                            border: "0px solid black",
                            position: "relative",
                            width: isMdOrDown ? 51 : 50,
                            height: isMdOrDown ? 51 : 50,
                          }}
                        >
                          <img
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 0,
                              left: 0,
                              bottom: 0,
                              borderRadius: 5,
                              boxShadow: `0px 4px 4px rgba(0, 0, 0, 0.25)`,
                              zIndex: 100,
                            }}
                            src={API.imgUrl + material.material_value}
                            width={isMdOrDown ? 51 : 50}
                            height={isMdOrDown ? 51 : 50}
                            alt="s"
                          />
                          {!checkSelected(material._id, single._id) ? (
                            ""
                          ) : (
                            <div
                              style={{
                                zIndex: 110,
                                position: "absolute",
                                top: 0,
                                right: 0,
                                left: 0,
                                bottom: 0,
                                border: "0px solid aqua",
                                display: "grid",
                                placeItems: "center",
                                background: "rgba(0,0,0,0.1)",
                              }}
                            >
                              <Check
                                size="large"
                                style={{
                                  color: "#000",
                                }}
                              />
                            </div>
                          )}
                        </div>
                      )}

                      <div
                        className="SDM_COMPO_materialTitle"
                        style={{
                          textAlign: "center",
                          wordBreak: "break-all",
                          fontWeight: isMdOrDown ? 500 : 500,
                          fontSize: isMdOrDown ? "12px" : "12px",
                          marginTop: "0.5rem",
                          marginBottom: isMdOrDown ? "0" : "0.5rem",
                          border: "0px solid red",
                        }}
                      >
                        {material.material_name}
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Components;
